import { BASE_URL_USER_ADMIN, BASE_URL_USER_EXTEND } from "../services/userAdminAPI";
import { CreateNewUserAdminRequest, User, UserExtend, UserExtendPatch, UserOrga, UserOrgaPatch, UserPatch } from "../types/user.types";
import { useAuth } from "../../auth/hooks";
import { Filter, useGenericAPI, useSingleGenericAPI } from "../../../utils/genericAPI/useGenericAPI";
import { useParams } from "react-router-dom";

/**
 * useAdminUser hook is used to manage the admin user data.
 * @returns
 */
export default function useAdminUser(congif?: {
  pageSize?: number;
  orderBy?: string;
  disableGet?: boolean;
  preFilter?: Filter<User>
}) {
  const { setHeaderAuthToRequest } = useAuth();

  setHeaderAuthToRequest();

  const { getAllQuery, createNew } = useGenericAPI<
    User,
    CreateNewUserAdminRequest,
    User
  >({
    baseURL: BASE_URL_USER_ADMIN,
    APIname: "admin-user",
    pageSize: congif?.pageSize,
    orderBy: congif?.orderBy as any,
    disableGet: congif?.disableGet,
    preFilter: congif?.preFilter
  });

  return {
    createNewAdminUserUCTQuery: {
      ...createNew,
    },
    getAllAdminUserQuery: {
      ...getAllQuery,
    },
  };
}

export const useSingleUser = (userId?: string) => {
  

  const { setHeaderAuthToRequest } = useAuth();
  const {userId : userIdUrl} = useParams()

  const userIdFound = userId || userIdUrl;
  setHeaderAuthToRequest();

  const { 
    singleQuery,
    deleteQuery,
    updateQuery,
    patchQuery
   } = useSingleGenericAPI<User, UserPatch>({
    baseURL: BASE_URL_USER_ADMIN,
    APIname: "admin-user",
    id: userIdFound,
  });

  const {
    getAllQuery: userOrgaListQuery
  } = useGenericAPI<UserOrga, UserOrgaPatch, UserOrgaPatch>({
    APIname: "user-orga-"+userIdFound,
    baseURL: BASE_URL_USER_ADMIN+"/"+userIdFound+"/user-orga",
  })

  return {
    singleUserQuery: singleQuery,
    deleteUser: deleteQuery,
    updateUser: updateQuery,
    patchUser: patchQuery,
    userOrgaListQuery,
    userIdFound
  };
}

export const useUserAdminExtend = (congif?: {
  pageSize?: number;
  orderBy?: string;
  disableGet?: boolean;
  preFilter?: Filter<UserExtendPatch>
}) => {
  const { setHeaderAuthToRequest } = useAuth();

  setHeaderAuthToRequest();

  const { getAllQuery } = useGenericAPI<UserExtend, UserExtendPatch, UserExtendPatch>({
    baseURL: BASE_URL_USER_EXTEND,
    APIname: "admin-user-extend",
    pageSize: congif?.pageSize,
    orderBy: congif?.orderBy as any,
    disableGet: congif?.disableGet,
    preFilter: congif?.preFilter
  })

  return {
    userAdminExtendListQuery: {
      ...getAllQuery,
    }
  }
}

export const useSingleUserExtend = (userOrgaId?: string) => {
  const { setHeaderAuthToRequest } = useAuth();
  const {userOrgaId: userOrgaIdUrl} = useParams()

  const userOrgaIdFound= userOrgaId|| userOrgaIdUrl;
  setHeaderAuthToRequest();

  const { 
    singleQuery,
    deleteQuery,
    updateQuery,
    patchQuery
   } = useSingleGenericAPI<UserExtend, UserExtendPatch>({
    baseURL: BASE_URL_USER_EXTEND,
    APIname: "admin-user-extend",
    id:  userOrgaIdFound,
  });

  return {
    singleUserExtendQuery: singleQuery,
    deleteUserExtend: deleteQuery,
    updateUserExtend: updateQuery,
    patchUserExtend: patchQuery,
    userOrgaIdFound
  };
}




